(function (root) {
  "use strict";

  var PRODUCTION_STATES = [
    "approved_for_production",
    "in_production",
    "quality_check",
  ];
  var SHIPMENT_STATES = [
    "ready_to_ship",
    "fulfillment_pending",
    "handed_off_to_office",
    "completed",
  ];

  function progressForWorkOrder(order) {
    var proofRequired = Boolean(order && order.proof_required);
    var state = String((order && order.state) || "pending_release");
    var stages = proofRequired
      ? ["proof", "production", "shipment"]
      : ["preparation", "production", "shipment"];
    var currentStage = stages[0];

    if (PRODUCTION_STATES.indexOf(state) !== -1) currentStage = "production";
    if (SHIPMENT_STATES.indexOf(state) !== -1) currentStage = "shipment";

    return {
      stages: stages,
      currentStage: currentStage,
      currentIndex: stages.indexOf(currentStage),
    };
  }

  function displayStateForOrder(order) {
    var state = String((order && order.state) || "");
    var hasZakekeDesign = Array.isArray(order && order.lines)
      ? order.lines.some(function (line) {
          return Boolean(line && line.zakeke_design_id);
        })
      : false;

    // "Declined" records what the supplier already did. Once a Zakeke design
    // is declined, the useful current status is who the workflow is waiting on.
    return state === "declined" && hasZakekeDesign
      ? "awaiting_customer_approval"
      : state;
  }

  function supplierBucketForState(state) {
    // Mirrors public.bb_supplier_bucket. A decline is not history: the order is
    // still live, waiting on corrected artwork from the customer or on staff to
    // reassign it. The server supersedes it into history once a replacement
    // work order exists.
    if (
      [
        "completed",
        "cancelled",
        "handed_off_to_office",
        "fulfillment_pending",
      ].indexOf(state) !== -1
    )
      return "history";
    if (state === "declined") return "waiting";
    if (
      [
        "awaiting_supplier",
        "preflight",
        "revision_requested",
        "approved_for_production",
        "ready_to_ship",
      ].indexOf(state) !== -1
    )
      return "action";
    if (["in_production", "quality_check"].indexOf(state) !== -1)
      return "progress";
    return "waiting";
  }

  function displayStateForBucket(order, bucket) {
    var state = String((order && order.state) || "");
    if (bucket === "history" && supplierBucketForState(state) !== "history")
      return "superseded";
    return displayStateForOrder(order);
  }

  function sortOrders(orders, selectedSort) {
    var mode = String(selectedSort || "newest");
    var urgencyRank = { overdue: 0, due_soon: 1, on_track: 2, no_date: 3 };
    return (Array.isArray(orders) ? orders : [])
      .slice()
      .sort(function (left, right) {
        if (mode === "priority") {
          var rankDifference =
            (urgencyRank[left.urgency] == null
              ? 4
              : urgencyRank[left.urgency]) -
            (urgencyRank[right.urgency] == null
              ? 4
              : urgencyRank[right.urgency]);
          if (rankDifference) return rankDifference;
        }
        if (mode === "priority" || mode === "due_asc") {
          var leftDue = String(left.supplier_due_date || "9999-12-31");
          var rightDue = String(right.supplier_due_date || "9999-12-31");
          if (leftDue !== rightDue) return leftDue.localeCompare(rightDue);
        }
        if (mode === "order_desc") {
          var leftOrder =
            Number(String(left.shopify_order_name || "").replace(/\D/g, "")) ||
            0;
          var rightOrder =
            Number(String(right.shopify_order_name || "").replace(/\D/g, "")) ||
            0;
          if (leftOrder !== rightOrder) return rightOrder - leftOrder;
        }
        var leftDate =
          mode === "updated_desc"
            ? left.updated_at
            : left.source_created_at || left.updated_at;
        var rightDate =
          mode === "updated_desc"
            ? right.updated_at
            : right.source_created_at || right.updated_at;
        var dateOrder = String(rightDate || "").localeCompare(
          String(leftDate || ""),
        );
        if (dateOrder) return dateOrder;
        return String(right.updated_at || "").localeCompare(
          String(left.updated_at || ""),
        );
      });
  }

  function reconcileSupplierAction(input) {
    input = input || {};
    var orders = Array.isArray(input.orders) ? input.orders : [];
    var actionResult = input.actionResult || {};
    var orderId = actionResult.id || input.selectedId;
    var currentOrder = orders.find(function (order) {
      return order.id === orderId;
    });
    var updatedOrder = Object.assign(
      {},
      currentOrder || { id: orderId },
      actionResult,
    );
    var previousBucket = supplierBucketForState(
      currentOrder ? currentOrder.state : updatedOrder.state,
    );
    var nextBucket = supplierBucketForState(updatedOrder.state);
    var moved = previousBucket !== nextBucket;
    var counts = Object.assign({}, input.counts || {});

    if (moved) {
      counts[previousBucket] = Math.max(
        0,
        Number(counts[previousBucket] || 0) - 1,
      );
      counts[nextBucket] = Number(counts[nextBucket] || 0) + 1;
      if (nextBucket === "history" && currentOrder) {
        if (currentOrder.urgency === "overdue")
          counts.overdue = Math.max(0, Number(counts.overdue || 0) - 1);
        if (currentOrder.urgency === "due_soon")
          counts.due_soon = Math.max(0, Number(counts.due_soon || 0) - 1);
      }
    }

    var nextOrders = orders
      .map(function (order) {
        return order.id === orderId ? updatedOrder : order;
      })
      .filter(function (order) {
        return supplierBucketForState(order.state) === input.activeBucket;
      });

    return {
      orders: nextOrders,
      counts: counts,
      selectedId:
        input.selectedId === orderId && nextBucket !== input.activeBucket
          ? ""
          : input.selectedId,
      moved: moved,
      previousBucket: previousBucket,
      nextBucket: nextBucket,
      updatedOrder: updatedOrder,
    };
  }

  root.BBSupplierWorkflowModel = {
    progressForWorkOrder: progressForWorkOrder,
    displayStateForOrder: displayStateForOrder,
    displayStateForBucket: displayStateForBucket,
    supplierBucketForState: supplierBucketForState,
    sortOrders: sortOrders,
    reconcileSupplierAction: reconcileSupplierAction,
  };
})(typeof window !== "undefined" ? window : this);
